import { ENVIRONMENT_LABEL, type ClientEnvironment, type ClientTarget } from '@features/clients';

/**
 * The environment of the specific-clients dialog: always the one this build is
 * deployed in, shown and never editable (spec: Environment is locked). The
 * clients list is read from `target`, so the selection can only name clients of
 * that environment.
 */
export interface ClientsEnvironmentView {
    readonly label: string;
    readonly locked: true;
    readonly editable: false;
    readonly target: ClientTarget;
}

export function clientsEnvironmentView(environment: ClientEnvironment): ClientsEnvironmentView {
    return {
        label: `Environment: ${ENVIRONMENT_LABEL[environment]}`,
        locked: true,
        editable: false,
        target: { env: environment },
    };
}
